export default {
	LOGIN: "api/login",
	DEPARTMENT: "api/departments",
	DEPARTMENT_SUMMARY: "api/department_summary",
	SUB_DEPARTMENT: "api/subdepartments",
	SUBDEPARTMENT_SUMMARY: "api/subdepartment_summary",
	ROLE: "api/roles",
	ROLE_SUMMARY: "api/role_summary",
	JOB_OPENING: "api/jobopenings",
	JOBOPENING_SUMMARY: "api/jobopening_summary",
	JOB_OPENING_APPLICANTS: "api/applicants/job_opening",
	CANDIDATE_DETAILS: "api/applicants",
	DELETE_APPLICANT: "api/applicants",
	JOB_INTERVIEW: "api/jobinterviews",
	CANCEL_INTERVIEW: 'api/jobinterviews/cancel',
	UPLOAD_RESUME: 'api/upload-resumes',
	GET_INTERVIEW_VIDEO_URL: 'api/video-interview',
	ORGANIZATION: "api/organisations",
	ORGANIZATION_SUMMARY: "api/organisation_summary",
	UPLOAD_QUESTIONS: '/api/jobopenings/upload-questions',
	CANDIDATE_LIST: "api/candidates",
	// JOB_INTERVIEW_FILTER: {
	// 	url: "api/jobinterviews/filter",
	// 	method: "POST"
	// },
	RESCHEDULE_INTERVIEW: {
		url: "api/jobinterviews/reschedule",
		method: "post"
	},
	FETCH_FEEDBACK_TRANSCRIPT: {
		url: "api/jobinterviews/feedback",
		method: "PUT"
	},
	JOB_INTERVIEW_STATUS: {
		url: "api/jobinterviews/status",
		method: "PUT"
	},
	EXPORT_JOB_INTERVIEWS: {
		url: "api/jobinterviews/export",
		method: "POST"
	},
	// New endpoint for prompts
	PROMPTS: '/api/prompts',
	APPLICANTS_FILTER: '/api/applicants/filter',
	UPDATE_SEND_EMAILS: '/api/jobopenings/update-send-emails',
	SEND_INTERVIEW_EMAILS: '/api/send-interview-emails',
	APPLICANTS_SEARCH: '/api/applicants/search',
	CANDIDATE_SEARCH: '/api/candidates/search',
	QUESTIONS: '/api/questions',
	QUESTIONS_FILTER: '/api/questions/filter',
	TAGS: '/api/tags',
	SKILLS: '/api/skills',
	JOB_CATEGORY: '/api/jobcategory',
	JOB_SUBCATEGORY: '/api/jobsubcategory',

	GET_REPORT_CARD:'api/jobinterviews/report-card' ,
	GET_CANDIDATE_REPORT_CARD:'api/jobinterviews/candidate-report-card' ,
	UPDATE_QUESTIONS: '/api/jobopenings/update-questions',
	// ... existing endpoints ...
	EXPORT_APPLICANTS: '/api/applicants/export',
	SEND_REPORT_CARD: 'api/jobinterviews/send-candidate-feedback',
	REQUEST_CANDIDATE_FEEDBACK: 'api/jobinterviews/feedback-request-email',
	QUESTION_BANK: 'api/jobopening/question-bank',
};
